import type { PropsWithChildren } from 'react';

import { Link } from '@remix-run/react';

type Props = PropsWithChildren<{
  href: string;
  isExternalLink: boolean;
  className?: string;
}>;

const VersatileLink = ({ href, children, className, isExternalLink }: Props) => {
  if (isExternalLink) {
    return (
      <a className={className} href={href} target="_blank" rel="nofollow noreferrer noopener">
        {children}
      </a>
    );
  }

  return (
    <Link className={className} to={href}>
      {children}
    </Link>
  );
};

export default VersatileLink;
